module.exports = __webpack_public_path__ + "images/cloudy-b02ea9a2b81064f8d7f91ffca95105e3.jpg";